import React, { useState, useContext, useEffect } from "react";
import {
  Modal,
  Container,
  Col,
  Spinner,
  Button,
  Row,
  Form,
  Alert,
} from "react-bootstrap";
import { Zoom } from "react-awesome-reveal";
// import { ArrowRightShort, ExclamationCircle, Bank2, XLg } from "react-bootstrap-icons";
import FactorPaymentListItem from "../Basket/Component/FactorPaymentListItem";
import { isMobile } from "react-device-detect";
import paymentImg from "../../../assets/images/payment.jpg";
import ContextApp from "../../../core/contexts/context.app";
import { useForm, Controller } from "react-hook-form";
import ApiUserPayment from "../../../core/api/api.userPayment";
import { BasketHelper } from "../../../core/utils/BasketHelper";
import SplitNumber from "../../components/SplitNumber";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import _ from "lodash";
import { Route, useLocation, useNavigate, Link } from "react-router-dom";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import ApiUserWallet from "../../../core/api/api.userWallet";
import ServiceStorage from "../../../core/services/service.storage";
import bankArray from "./bankArray";
import {
  IconArrowRight,
  IconErrorCircle,
  IconCard,
  IconCoinBag,
  IconTags,
  IconWallet,
} from "../../../assets/icons";
import classnames from "classnames";
import LoadingDottedButton from "../../components/LoadingDottedButton";

function Payment() {
  let location = useLocation();
  const navigate = useNavigate();
  const ctx = useContext(ContextApp);
  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
  } = useForm({ defaultValues: { id: 0 } });
  const [portalList, setPortalList] = useState([]);
  // const [kindOfPay, setKindOfPay] = useState([]);
  const [walletAmont, setWalletAmont] = useState(0);
  const [gateWayShow, setGateWayShow] = useState(true);

  const [liveData, setLiveData] = useState({
    basketItemTemps: [],
  });
  const [isLoading, setIsLoading] = useState(true); // لود اولیه صفحه
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    (async () => {
      try {
        // بررسی اولیه و سریع با ctx
        if (
          !ctx.isAuth ||
          _.isEmpty(ctx.userInfo) ||
          _.isEmpty(_.trim(ctx.userInfo?.name))
        ) {
          let path = "/login?r=payment";
          navigate(path, { state: { prevPath: location.pathname } });
          return;
        }

        // دریافت اخرین سبد خرید فعال نیاز به لاگین دارد
        const basket = await BasketHelper.getBasketOfDB(ctx);
        if (!_.isEmpty(basket)) setLiveData(basket);

        //getwallet
        const result = await ApiUserWallet.getWalletBalance();

        // در صورت تغییر مبلغ کیف پول مبلغ کیف پول ویرایش شود
        if (
          !_.isEmpty(result) &&
          !_.isEmpty(result.data) &&
          _.isNumber(result.data.useAvailableRiallBalance) &&
          result.data.useAvailableRiallBalance >= 0
        ) {
          setWalletAmont(result.data.useAvailableRiallBalance);
          // دریافت اطلاعات کاربر
          let userInfo = _.isEmpty(ServiceStorage.getUserInfo())
            ? { walletRiallBalance: 0 }
            : ServiceStorage.getUserInfo();
          if (
            !_.isEmpty(userInfo) &&
            !_.isEqual(
              userInfo.walletAvailableRiallBalance,
              result.data.useAvailableRiallBalance
            )
          ) {
            //
            //ویرایش اطلاعات کاربر
            userInfo.walletRiallBalance = result.data.riallBalance;
            userInfo.walletAvailableRiallBalance =
              result.data.useAvailableRiallBalance;
            ServiceStorage.setUserInfo(userInfo);
            ctx.setUserInfo(userInfo);
          }
        } else setWalletAmont(0);

        // دریافت درگاه ها
        const response = await ApiUserPayment.getActivePortalList({});

        setPortalList(response.data);

        setIsLoading(false);

        if (
          ctx.isAuth &&
          !_.isNull(result.data.useAvailableRiallBalance) &&
          result.data.useAvailableRiallBalance > 0 &&
          result.data.useAvailableRiallBalance >= basket.price
        )
          setGateWayShow(false);
        else setGateWayShow(true);

        // برای قرار دادن حق نوع پرداخت به کاربر
        // if (ctx.isAuth) {
        //     const basketAmont = basket.originalPrice;
        //     const walletAmont = (!_.isEmpty(ctx.userInfo) && !_.isEmpty(ctx.userInfo.walletRiallBalance)) ? ctx.userInfo.walletRiallBalance : 0;
        //
        //     if (walletAmont > basketAmont) {

        //         setKindOfPay([{ value: "1", title: "پرداخت از طریق درگاه" }, { value: "2", title: "پرداخت از حساب کاربری" }]);
        //         setValue("kindOfPay", "1");
        //         setValue("price", basketAmont);
        //     }

        // }
        // else {
        //     setKindOfPay([{ value: "1", title: "پرداخت از طریق درگاه" }]);
        // }
      } catch (error) {}
    })();
    return () => {};
  }, [ctx.isAuth]);

  const onSubmit = async (data) => {
    if (liveData.price === 0) {
      return (window.location.href = "/basket");
    }
    try {
      data.basketTempId = liveData.id;

      if (
        ctx.isAuth &&
        !_.isEmpty(ctx.userInfo) &&
        !_.isEmpty(_.trim(ctx.userInfo.name))
      ) {
        //فراخوان تابع ارسال به درگاه
        let response = await ApiUserPayment.payment(data);
        if (response.succeeded && response.data != null) {
          if (
            response.data.basketPaymentStatusId != null &&
            response.data.basketPaymentStatusId == 0
          ) {
            return (window.location.href =
              "/afterPay?bid=" + response.data.basketId);
          } else if (response.data.link != "") {
            return (window.location.href =
              process.env.REACT_APP_API_URL +
              "?redirectId=" +
              response.data.link);
          } else {
            // toast.configure();
            toast(response.data.message, { position: "top-center" });
          }
        } else {
          //toast.configure();
          toast(response.message, { position: "top-center" });
        }
      } else {
        //باز کردن لاگین
        let path = "/login?r=p";
        navigate(path, { state: { prevPath: location.pathname } });
        // toast.configure();
        // toast("جهت ادامه فرایند خرید ابتدا وارد اکانت خود شوید");
      }
    } catch (error) {
    } finally {
    }
  };

  return (
    <SkeletonTheme baseColor="#cecdcd" highlightColor="#e2dfdf">
      {/* <ToastContainer position="top-center" rtl="true" /> */}
      <Container fluid className=" min-height-page">
        <Container className="main-content transaction-box">
          <Row>
            <form onSubmit={handleSubmit(onSubmit)}>
              <Row className=" pt-3 pt-xl-5 justify-content-center">
                <Col xs={12} lg={gateWayShow ? 4 : 7} className="px-0 px-sm-3">
                  <Row>
                    <Col>
                      <div className="shadow-sm bg-white p-3 pb-2 rounded-3 basket-box">
                        <Col xs={12} className="">
                          <h3 className="fs-normal text-center text-xl-start  border-bottom fw-bold pt-xl-2 pb-3">
                            خلاصه سبد خرید شما
                          </h3>
                        </Col>

                        <Row className="px-2 my-auto gx-4">
                          <FactorPaymentListItem
                            FactorItemTitle="تعداد تفریحات"
                            FactorItemCount={
                              liveData.basketItemTemps.filter(
                                (e) => e.isDeleted === false
                              ).length + " تفریح"
                            }
                            styleNameClass1=" fs-085  text-dark text-start px-0"
                            styleNameClass2="  text-dark text-end  px-0  "
                            isLoading={isLoading}
                            isLine={false}
                            itemIcon={<IconTags fillColor="#444" />}
                          />

                          <FactorPaymentListItem
                            FactorItemTitle="قیمت نهایی"
                            FactorItemCount={liveData.price + " تومان"}
                            styleNameClass1="text-dark fs-085 text-start  px-0 "
                            styleNameClass2="text-dark text-end  px-0 "
                            isLoading={isLoading}
                            isLine={false}
                            itemIcon={<IconCoinBag fillColor="#444" />}
                          />
                          <FactorPaymentListItem
                            FactorItemTitle="اعتبار کیف پول"
                            FactorItemCount={walletAmont + " تومان"}
                            styleNameClass1="text-dark  fs-085 text-start  px-0  "
                            styleNameClass2="text-dark text-end   px-0 "
                            isLoading={isLoading}
                            isLine={false}
                            itemIcon={<IconWallet fillColor="#444" />}
                          />
                          {/* <div className="border-top mt-2 pt-2"></div> */}
                          {ctx.isAuth &&
                          _.isNumber(walletAmont) &&
                          walletAmont < liveData.price ? (
                            <FactorPaymentListItem
                              FactorItemTitle="مبلغ قابل پرداخت"
                              FactorItemCount={
                                liveData.price - walletAmont + " تومان"
                              }
                              styleNameClass1="text-success fw-bold    fs-085  px-0 text-start"
                              styleNameClass2="text-success fs-101 fw-bold text-end   px-0 "
                              isLoading={isLoading}
                              isLine={false}
                              itemIcon={<IconCard fillColor="#444" />}
                            />
                          ) : (
                            <FactorPaymentListItem
                              FactorItemTitle="مبلغ قابل پرداخت"
                              FactorItemCount="0 تومان"
                              styleNameClass1="text-success fw-bold   fs-085  px-0 text-start"
                              styleNameClass2="text-success  fs-101 fw-bold text-end   px-0 "
                              isLoading={isLoading}
                              isLine={false}
                              itemIcon={<IconCard fillColor="#444" />}
                            />
                          )}
                        </Row>
                      </div>
                    </Col>
                  </Row>

                  {ctx.isAuth &&
                  _.isNumber(walletAmont) &&
                  walletAmont >= liveData.price ? (
                    <Row className=" mt-2">
                      <Col xs={12} className="mt-0 ">
                        <Alert
                          variant="secondary"
                          className="rounded-3 text-small mb-2 mb-lg-2"
                        >
                          <IconErrorCircle fillColor="#000" />
                          مبلغ{" "}
                          {isLoading ? (
                            <span className="">
                              {" "}
                              <Skeleton width={50} /> تومان از کیف پول شما کسر
                              خواهد شد.{" "}
                            </span>
                          ) : (
                            <span>
                              {" "}
                              <span className="fw-bolder">
                                {" "}
                                <SplitNumber number={liveData.price} />{" "}
                              </span>
                              تومان از کیف پول شما کسر خواهد شد.{" "}
                            </span>
                          )}{" "}
                        </Alert>
                      </Col>
                      {/* <Col xs={12} className="  mt-3">
                    {" "}
                    <h3> اعتبار مورد نیاز شما جهت انجام این سفارش مبلغ : </h3>
                  </Col>
                  <Col xs={12} className="  mt-3">
                    {" "}
                    <h3>
                      {" "}
                      {isLoading ? <span> <Skeleton width={50} /> تومان می باشد </span> :
                        <SplitNumber number={liveData.price - walletAmont + "  تومان می باشد"} />} {" "}
                    </h3>
                  </Col> */}
                    </Row>
                  ) : null}
                </Col>
                <Col xs={12} lg="7" className="px-0 px-sm-3">
                  {!gateWayShow ? (
                    <Row className="  ">
                      <Col xs={12} lg={7} className="  ">
                        <div className="d-lg-flex white-space-nowrap ">
                          {!isSubmitting ? (
                            <button
                              type="submit"
                              className="btn btn-success w-100 rounded-2"
                              style={{
                                height: "44px",
                                paddingRight: "5rem",
                                paddingLeft: "5rem",
                              }}
                            >
                              {walletAmont >= liveData.price
                                ? "ثبت نهایی"
                                : "پرداخت از طریق کارت بانکی"}
                            </button>
                          ) : (
                            <button
                              disabled
                              type="submit"
                              className="btn btn-success w-100 rounded-2"
                              style={{
                                height: "44px",
                                paddingRight: "5rem",
                                paddingLeft: "5rem",
                              }}
                            >
                              {walletAmont >= liveData.price ? (
                                <LoadingDottedButton btnText="ثبت نهایی" />
                              ) : (
                                <LoadingDottedButton btnText="پرداخت از طریق کارت بانکی" />
                              )}
                            </button>
                          )}
                          {/* <Button
                            variant="success"
                            className="w-100"
                            type="submit"
                            style={{
                              height: "44px",
                              paddingRight: "5rem",
                              paddingLeft: "5rem",
                            }}
                            disabled={isSubmitting}
                          >
                            {isSubmitting && (
                              <Spinner
                                animation="border"
                                variant="warning"
                                size="sm"
                              />
                            )}
                            {walletAmont >= liveData.price
                              ? "ثبت نهایی"
                              : "پرداخت از طریق کارت بانکی"}
                          </Button> */}
                          {!isMobile && (
                            <Link
                              to="/basket"
                              className="btn btn-outline-success ms-2  d-flex align-items-center fs-085"
                              style={{ height: "44px" }}
                            >
                              بازگشت به سبد خرید
                            </Link>
                          )}
                        </div>
                      </Col>
                    </Row>
                  ) : (
                    <Row className="mt-2 mt-lg-0 gx-0">
                      <Col
                        xs={12}
                        className="
                        text-right my-auto mb-3"
                      >
                        <div className=" bg-white rounded-3  shadow-sm basket-box  p-3">
                          <Row className="">
                            <Col xs={12} lg={5}>
                              <div className="border-bottom pb-2 mb-2">
                                <h3 className="fw-bold fs-normal text-center text-xl-start">
                                  درگاه مورد نظر را انتخاب نمایید
                                </h3>
                                {/* <div className="text-small mt-1">
                          <ExclamationCircle size={15} className="text-muted ml-1" />
                          <span className="text-muted">قابل پرداخت توسط تمامی کارت های بانکی </span>
                        </div> */}
                              </div>
                              {isLoading ? (
                                <Row
                                  className={
                                    "mb-2 border rounded-3 p-2 d-flex align-items-center gx-0"
                                  }
                                >
                                  <Col
                                    xs="auto"
                                    className="pl-0 d-flex align-items-center"
                                  >
                                    <input
                                      type="radio"
                                      name="userPaymentTypeId"
                                      className="option-input radio "
                                    />
                                  </Col>
                                  <Col className="pr-0 fw-bold">
                                    <span>
                                      <Skeleton />{" "}
                                    </span>
                                  </Col>
                                </Row>
                              ) : (
                                portalList?.map((item, index) => (
                                  <Row
                                    key={index}
                                    className={
                                      "mb-2 border rounded-3 p-2 d-flex align-items-center gx-0"
                                    }
                                  >
                                    <Col
                                      xs="auto"
                                      className="pl-0 d-flex align-items-center"
                                    >
                                      <input
                                        {...register("userPaymentTypeId")}
                                        type="radio"
                                        name="userPaymentTypeId"
                                        value={item.id}
                                        id="field-rain"
                                        className="option-input radio "
                                        defaultChecked={index == 0}
                                      />
                                    </Col>
                                    <Col className="pr-0 fw-bold">
                                      {/* <img src={item.imageUrl} width={40} /> */}
                                      <label for="userPaymentTypeId">
                                        {item.titleShow}
                                      </label>
                                    </Col>
                                  </Row>
                                ))
                              )}

                              <div className=" mx-1 text-center mx-xl-0 ">
                                {!isSubmitting ? (
                                  <button
                                    type="submit"
                                    className={` w-100  btn btn-success ${
                                      isMobile ? " w-100" : "w-50"
                                    }`}
                                  >
                                    {walletAmont >= liveData.price
                                      ? "ثبت نهایی"
                                      : "پرداخت"}
                                  </button>
                                ) : (
                                  <button
                                    disabled
                                    type="submit"
                                    className={` w-100  btn btn-success ${
                                      isMobile ? " w-100" : "w-50"
                                    }`}
                                  >
                                    {walletAmont >= liveData.price ? (
                                      <LoadingDottedButton btnText="ثبت نهایی" />
                                    ) : (
                                      <LoadingDottedButton btnText="پرداخت" />
                                    )}
                                  </button>
                                )}
                                {/* <Button
                                  variant="success"
                                  className={` w-100  btn btn-success ${
                                    isMobile ? " w-100" : "w-50"
                                  }`}
                                  type="submit"
                                  disabled={isSubmitting}
                                >
                                  {isSubmitting && (
                                    <Spinner
                                      animation="border"
                                      variant="warning"
                                      size="sm"
                                    />
                                  )}
                                  {walletAmont >= liveData.price
                                    ? "ثبت نهایی"
                                    : "پرداخت"}
                                </Button> */}
                              </div>
                            </Col>

                            <Col xs={12} lg={7}>
                              <div>
                                <div className="bg-gray p-2 rounded-3 my-3 text-center">
                                  <div className="text-small  my-2 text-center">
                                    {/* <ExclamationCircle size={15} className="text-muted ml-1" /> */}
                                    <span className="text-muted">
                                      قابل پرداخت توسط تمامی کارت های بانکی{" "}
                                    </span>
                                  </div>
                                  {bankArray.map((bank, key) => {
                                    return (
                                      <button
                                        key={key}
                                        className="btn-sm btn-no-style py-1 mx-1 my-1 bg-white text-dark border-0"
                                        type="submit"
                                        disabled={isSubmitting}
                                      >
                                        <img
                                          src={bank.imgPath}
                                          width={25}
                                          height={25}
                                        />
                                      </button>
                                    );
                                  })}
                                </div>
                              </div>
                            </Col>

                            {/* {isMobile ? null : (
                          <Row>
                            <img src={paymentImg} className="img-fluid px-2" />
                          </Row>
                        )} */}
                          </Row>
                        </div>
                      </Col>
                    </Row>
                  )}
                </Col>
              </Row>
            </form>
          </Row>
        </Container>
      </Container>
    </SkeletonTheme>
  );
}
export default Payment;
